import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { SharedModule } from "@shared";
import { LayoutModule } from "@layout";
// dashboard pages
// single pages
import { RouteRoutingModule } from "./routes-routing.module";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzResultModule } from "ng-zorro-antd/result";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { ProvisioningModule } from "./provisioning/provisioning.module";
import { BillingModule } from "./billing/billing.module";

import { TokenService } from "@delon/auth";
import { ProfileModule } from "./profile/profile.module";
import { NotificationsModule } from "./notifications/notifications.module";
import { EnquiryModule } from "./enquiry/enquiry.module";

@NgModule({
  imports: [
    SharedModule,
    LayoutModule,
    RouteRoutingModule,
    NzCollapseModule,
    NzSkeletonModule,
    NzPageHeaderModule,
    NzResultModule,
    ProvisioningModule,
    BillingModule,
    EnquiryModule,
    ProfileModule,
    NotificationsModule,
  ],

  declarations: [],
  providers: [TokenService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RoutesModule {}
